export default "__VITE_ASSET__CaFFE9H8__"